import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.grey[200],
  width: '100%',
  borderRadius: 1,
  height: 'fit-content',
};
